import { put, takeLatest } from "redux-saga/effects";
import { updateLanguage } from "./actions";
import { getLanguageByCode } from "./languages";
import { LanguageActionTypes } from "./constants";

function* changeLanguage(action: { payload: string }) {
  const langCode = action.payload;
  const language = getLanguageByCode(langCode);

  if (language) {
    const { name, flag } = language;
    yield put(updateLanguage(langCode, name, flag));
  } else {
    console.error(`Language code ${langCode} not found`);
  }
}

function* languageSaga() {
  // takeLatest(actionType, saga) — TS wrongly picks channel overload; runtime is correct
  // @ts-expect-error redux-saga overload resolution treats enum as TakeableChannel
  yield takeLatest(LanguageActionTypes.CHANGE_LANGUAGE, changeLanguage);
}

export default languageSaga;
